
















































import Vue from 'vue';
import NOC from '@/class/common/const';
import { moment } from '@/class';

// api
import API from '@/api/common';

import * as models from '@/class/models/views/news';

import SideMenu from '@/components/util/SideMenu.vue';
import SimpleList from '@/components/util/SimpleList.vue';

export default Vue.extend({
  name: 'News',
  components: {
    SideMenu, SimpleList,
  },
  data() {
    return {
      onload: false,
      newsList: [] as models.INews[],
      newsRows: 0 as number,
      setNewsDetaile: {} as models.INews,
      showDetaile: false,
    };
  },
  async mounted() {
    await Promise.all([this.getNewsList()]);
    if (this.$route.params.news_id) {
      const data = this.newsList.find((v) => String(v.news_id) === this.$route.params.news_id);
      if (data) {
        this.openDetaile(data);
      }
    }
    if (this.$route.query.news_id) {
      const data = this.newsList.find((v) => String(v.news_id) === this.$route.query.news_id);
      if (data) {
        this.openDetaile(data);
      }
    }

    // 読み込み完了
    this.onload = true;
  },
  computed: {
    moment(): any {
      return moment;
    },
    categories() {
      return NOC.NEWS.CATEGORY;
    },
  },
  watch: {
    $route(to) {
      console.log(to);
      // const data = this.newsList.find((v) => String(v.news_id) === this.$route.params.news_id);
      const data = this.newsList.find((v) => String(v.news_id) === this.$route.query.news_id);
      if (data) {
        this.openDetaile(data);
        this.showDetaile = true;
      }
    },
  },
  methods: {
    async getNewsList() {
      const api = new API();
      const res = await api.get<models.VNews>('news');
      if (res.result) {
        this.newsList = res.data.news;
        this.newsRows = res.data.news.length;
      } else {
        this.$emit('change', NOC.APP.MODE.LOGIN);
      }
    },
    openDetaile(data: models.INews) {
      this.showDetaile = true;
      this.setNewsDetaile = data;
      this.newsCheck(data);
    },
    closeDetaile() {
      this.showDetaile = false;
    },
    async newsCheck(news: models.INews) {
      const api = new API();
      if (!news.checked) {
        try {
          await api.post<any, models.VNewsConfirmation>('news/confirmation', {
            news_id: news.news_id,
          });
          news.checked = true;
        } catch (e) {
          console.log(e);
        }
        this.$emit('check-news', news);
        (this.$parent.$refs.topBar as any).updateDisplayedItem(news, news.news_id);
      }
    },
    changeCode(data: string) {
      return data ? data.replace(/\\n/g, '\n') : '';
    },
  },
});
